$(document).ready(function() {
  const documentRemovalButtons = document.querySelectorAll(".delete-document");

  if (documentRemovalButtons.length === 0) { return null };

  documentRemovalButtons.forEach(button => {
    button.addEventListener("click", (event) => {
      const fileInputName = event.currentTarget.dataset.fileField
      const fileInput = document.querySelector(`#${fileInputName}`);
      fileInput.click();
    })
  })
});
